// i18n area 'storage' — locale sq-AL (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.sq-AL.meta.json.
import type { enUS } from './storage'

export const sqAL: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Krijo storage',
      path: 'Shtegu',
      pathHint: 'Shteg absolut nën një root të lejuar (default /var/lib/tvirt/pools/)',
      shared: 'Storage i përbashkët',
      sharedChip: 'i përbashkët',
      sharedVerifiedChip: 'i përbashkët · i verifikuar',
      sharedVerifiedTooltip: 'Ndarje e verifikuar: sondat e kryqëzuara konfirmojnë që secili anëtar i sheh të dhënat e shkruara nga të tjerët.',
      sharedDisputedChip: 'i përbashkët · I PAVERIFIKUAR',
      sharedDisputedTooltip: 'Ndarje E PAVERIFIKUAR',
      sharedDisputedPair: '{observer} nuk i sheh të dhënat e shkruara nga {writer}',
      sharedHint: 'Share rrjeti e montuar lokalisht në të njëjtin shteg në secilin anëtar — parakushti i live migration-it (deklarativ).',
      sharedDanger: 'RREZIK — TVirt e BESON këtë flag: duke e ndezur, secili anëtar supozon se sheh TË NJËJTAT byte në këtë shteg. Mbi një dosje që NUK është një share vërtet e përbashkët (NFS/CIFS/sistem skedarësh klasteri) rezultati është korruptim dhe humbje të dhënash në migrimin e parë ose në rinisjen e parë HA në një nyjë tjetër. Ndize vetëm nëse shtegu është një share e montuar në mënyrë identike në çdo nyjë.',
      type: 'Tipi',
      capacity: 'Kapaciteti',
      provisioned: 'E alokuar',
      provisionedOvercommit: 'Angazhim potencial përtej kapacitetit: volumet thin mund të rriten deri në {n} GiB.',
      phase: { ready: 'Gati', degraded: 'I degraduar', error: 'Gabim' },

      // Round #156 (dialog standard): il dialog dettagli COMPLETO — tab,
      // le righe di config per-driver e la superficie osservata.
      tabConfig: 'Konfigurimi',
      tabCapacity: 'Kapaciteti dhe gjendja',
      cardIdentity: 'Identiteti',
      cardPlacement: 'Vendndodhja',
      cardConnection: 'Lidhja',
      usedReal: 'Zënia reale',
      capacityUnknown: 'Nyja nuk e ka raportuar ende kapacitetin e këtij pool-i — këtu nuk shpiken numra',
      overcommitHint: 'Angazhim përtej kapacitetit: legjitim mbi pool-et thin, mbaje nën vëzhgim zënien reale',
      supportedContent: 'Përmbajtje të mbështetura',
      content: {
        disks: 'Disqe',
        catalogFiles: 'Skedarë katalogu',
        backups: 'Backup-e',
        appVolumes: 'Volume App'
      },
      defaultDiskFormat: 'Formati i parazgjedhur i disqeve',
      reserveGiB: 'Hapësirë e lirë e rezervuar (GiB)',
      available: 'E disponueshme',
      diskCount: 'Disqe',
      filesystem: 'Filesystem',
      observedAt: 'Vëzhguar më',
      lostAtRow: 'Deklaruar i humbur më',
      sharedProbeRow: 'Verifikimi i ndarjes',
      sharedProbeNodes: 'Nyjet e sonduara',
      reachableFrom: 'Arritshmëria e deklaruar',
      reachableFromHint: 'Nyjet nga të cilat ky storage duhet të jetë i arritshëm. Një VM me disqe, ISO ose metadata këtu nuk niset dhe as migron në një nyjë jashtë kësaj liste. Të gjithë anëtarët janë të parazgjedhur: ngushtoje si të duash. Një nyjë që hyn në klaster më vonë mbetet jashtë derisa ta shtosh këtu.',
      reachableFromNone: 'e padeklaruar',
      reachableFromTags: 'Arritshmëria sipas tag-eve',
      reachableFromTagsHint: 'Selektor tag=vlerë (zëra të ndarë me presje, në AND): çdo anëtar që i mbart këto tag-e deklarohet i arritshëm — dinamikisht: tag-imi i një nyje e fut brenda.',
      reachableFromTagsInvalid: 'Format i pavlefshëm — përdor tag=vlerë, të ndarë me presje',
      reachableResolved: 'Nyjet e zgjidhura: {nodes}',
      reachableDeclaredNotSeen: 'i deklaruar por i paparë nga sonda e ndarjes në: {nodes}',
      reachableSeenNotDeclared: 'i parë por i padeklaruar (jashtë perimetrit) në: {nodes}',
      cephCluster: 'Klaster Ceph i menaxhuar',
      appGuardTitle: 'Storage në përdorim nga App-et',
      appEphemeralGuard: 'ky storage është pool-i efemer i klasterit i App-eve — ndryshoje më parë nga faqja App, pastaj fshije.',
      appInUseGuard: 'këtu jetojnë root/volume app-esh: {apps} — zhvendosi ose fshiji më parë.',
      releaseRequiredTitle: "Të fshihet '{name}' dhe të lirohen imazhet e tij?",
      releaseRequiredBatchTitle: 'Të fshihen storage-t e zgjedhur dhe të lirohen imazhet e tyre?',
      releaseRequiredBody: 'Lirimi i imazheve nuk fshin ASNJË bajt: çregjistrimi e lë namespace-in në disk, imazhet thjesht nuk janë më të materializuara dhe çdo referencë e scope-ve mbijeton si claim — regjistroje sërish pool-in dhe ato ribirësohen.',
      releaseConfirm: 'Fshi dhe liro imazhet'
    },
    lost: {
      chip: 'I humbur',
      action: 'Deklaro të humbur',
      confirmTitle: 'Deklaro storage-in të humbur',
      confirmBody: 'Atestim i operatorit me rrezik të deklaruar të vetin: çdo task në radhë ose në ekzekutim mbi këtë storage ose objektet e tij DO TË DËSHTOJË, fshirjet bëhen vetëm në regjistër (asnjë punë mbi filesystem) dhe puna e re fizike refuzohet. Byte-t nuk preken kurrë — nëse volumi kthehet në jetë, regjistroje sërish dhe ekzekuto një scan për të ri-adoptuar gjithçka.',
      confirmSubmit: 'Deklaro të humbur',
      error: 'Atestimi u refuzua'
    },
    findings: {
      action: 'Objekte të gjetur',
      title: 'Objekte të gjetur',
      empty: 'Asnjë objekt i gjetur në namespace-in e storage-it',
      loadError: 'Objektet e gjetur nuk mund të ngarkoheshin',
      actionError: 'Vendimi u refuzua',
      colKind: 'Tipi',
      colObject: 'Objekti',
      colConflict: 'Konflikti',
      namespaceNotice:
        'Kjo direktori ishte inicializuar tashmë nga një ruajtje tjetër: vula e identitetit është rishkruar me atë të kësaj ruajtjeje. Përmbajtja NUK është prekur — shiko objektet e gjetura më poshtë, importo ato që të duhen dhe pastaj hidhe këtë njoftim.',
      kind: {
        disk: 'Disk',
        catalogFile: 'Skedar katalogu',
        vmMetadata: 'Metadata VM',
        namespace: 'Namespace',
        foreign: 'I huaj',
        volumeGroup: 'Grup volumesh'
      },
      vgAdopt: {
        action: 'Adopto grupin e volumeve',
        title: 'Adopto grupin e volumeve',
        intro:
          'Kjo pajisje mban tashmë një grup volumesh me një emër të TVirt, por vula e tij nuk emërton asnjë storage të regjistruar këtu. Mund të jetë ajo që një storage i mëparshëm i KËTIJ klasteri la në LUN — ose ajo që NJË TJETËR klaster TVirt la në një LUN që ndërroi duar: nga këtu të dyja rastet duken njësoj, dhe prandaj askush nuk vendos në vendin tuaj.',
        irreversible: 'Shikoni pajisjen, vulën dhe emrin para se të vazhdoni: adoptimi nuk kthehet mbrapsht.',
        device: 'Pajisje',
        seal: 'Vulë',
        sealNone: 'asnjë (pa etiketë tvirt.storageId)',
        renameTo: 'Do të riemërtohet në',
        renameNone: 'Pa riemërtim: emri është tashmë ai që nxjerr ky storage',
        volumesNote:
          'Volumet brenda NUK adoptohen nga ky veprim: skanimi i radhës i ofron një nga një, si objekte të gjetura të zakonshme.'
      },
      conflictChip: 'ID tashmë ekzistuese',
      dismissedChip: 'I injoruar',
      adopt: 'Adopto',
      adoptFileTitle: 'Importo në një katalog',
      adoptFileHint: 'Skedarët ekzistojnë vetëm brenda katalogëve: zgjidh katalogun e destinacionit për skedarin e gjetur.',
      purge: 'Fshi nga disku',
      dismiss: 'Injoro',
      purgeConfirmTitle: 'Fshi nga disku',
      purgeConfirmBody: 'Byte-t e gjetur të {id} do të hiqen nga storage-i. Operacioni nuk është i kthyeshëm.',
      taskStarted: 'U nis — vazhdon si task në background',
      scan: 'Skano storage-in',
      scanStarted: 'Skanimi u nis…',
      scanDone: 'Skanimi përfundoi — objektet e gjetur janë të përditësuar'
    },
    reinit: {
      action: 'Riprovo inicializimin'
    },
    wizard: {
      addButton: 'Shto',
      title: 'Shto storage',
      back: 'Prapa',
      continue: 'Vazhdo',
      selectHint: 'Zgjidh një protokoll për të parë si e përdor TVirt.',
      roadmap: 'Roadmap',
      server: 'Server',
      export: 'Shtegu i eksportuar',
      share: 'Share',
      username: 'Emri i përdoruesit',
      password: 'Fjalëkalimi',
      passwordHint: 'Vetëm në shkrim: përdoret për mount-in, nuk shfaqet më kurrë.',
      credential: 'Kredenciali',
      credentialManual: 'Shkruaji manualisht',
      credentialHint: 'Një zë i keystore-it i tipit emër përdoruesi dhe fjalëkalim — alternativa ndaj shtypjes së tyre këtu.',
      credentialEmpty: 'Asnjë kredencial i tipit emër përdoruesi dhe fjalëkalim në keystore — krijoje te Sistemi → Kredencialet, ose shkruaje llogarinë këtu poshtë.',
      options: 'Opsionet e mount-it',
      optionsHint: 'Të ndara me presje, i kalohen mount -o ashtu siç janë.',
      portal: 'Portal',
      portalHint: 'host[:portë] — porta e parazgjedhur është 3260.',
      target: 'Target IQN',
      targetHint: 'Emri i target-it iSCSI, fillon me iqn.',
      lun: 'LUN',
      wholeLunRow: 'Në disqe: kjo hapësirë emërton vetëm target-in',
      wholeLunHint: 'Kjo hapësirë emërton vetëm target-in: LUN-ët e saj bëhen disqe një nga një (Krijo disk → adopto një LUN të plotë), në target nuk shkruhet asgjë.',
      lunHint: 'Numri i LUN-it në target — 0 në mëdyshje.',
      chapCredential: 'Kredenciali (CHAP)',
      chapCredentialHint: 'Një zë i keystore-it i tipit CHAP (iSCSI) i përdorur për login-in — sekreti nuk udhëton kurrë me storage-in.',
      chapNone: 'Asnjë autentikim',
      chapEmpty: 'Asnjë kredencial i tipit CHAP (iSCSI) në keystore — krijoje te Sistemi → Kredencialet. Pa të, login-i mbetet i paautentikuar.',
      address: 'Adresa',
      addressHint: 'Host ose IP i target-it NVMe/TCP (traddr).',
      port: 'Porta',
      portHint: 'Porta TCP e target-it — 4420 nëse lihet bosh.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'NQN-ja e subsystem-it në target, fillon me nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID brenda subsystem-it — 1 në mëdyshje.',
      dhchapCredential: 'Kredenciali (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Një zë i keystore-it i tipit DH-HMAC-CHAP (NVMe) i përdorur në lidhje — sekreti nuk udhëton kurrë me storage-in.',
      dhchapNone: 'Asnjë autentikim',
      dhchapEmpty: 'Asnjë kredencial i tipit DH-HMAC-CHAP (NVMe) në keystore — krijoje te Sistemi → Kredencialet. Pa të, lidhja mbetet e paautentikuar.',
      monitors: 'Monitorët',
      monitorsHint: 'Endpoint-et e monitorëve Ceph, host[:portë], të ndarë me presje ose me rresht të ri — porta e parazgjedhur 6789.',
      pool: 'Pool',
      poolHint: 'Pool-i RBD për t’u konsumuar — një imazh RBD për disk.',
      fs: 'Filesystem',
      fsHint: 'Emri i filesystem-it CephFS (mds_namespace në mount).',
      fsPath: 'Shtegu brenda filesystem-it',
      fsPathHint: 'Shteg absolut brenda filesystem-it që storage-i monton — / në mëdyshje.',
      cephxCredential: 'Kredenciali (cephx)',
      cephxCredentialHint: 'Një zë i keystore-it i tipit cephx: emri i përdoruesit = emri i klientit (client.…), sekreti = çelësi base64. I detyrueshëm.',
      cephxNone: 'Asnjë kredencial cephx në keystore — krijo një (tip: cephx) te Sistemi → Kredencialet, ose lëre që një klaster Ceph i menaxhuar ta farkëtojë me "Propozo si storage".',
      sharedByNature: 'Storage-et e rrjetit janë të përbashkët nga natyra: secili anëtar i monton në të njëjtin shteg të menaxhuar nga TVirt.',
      error: 'Storage-i u refuzua',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Tjetër',
        legacy: 'Legacy'
      },
      legacyHint: 'Të mbështetur plotësisht — thjesht nuk do t’i zgjidhnim për një instalim të ri.',
      proto: {
        // La riga `usage` (Luca 2026-07-24) dice come TVirt usa il protocollo —
        // in primis i contenuti ammessi: dir/nfs/cifs ospitano dischi E immagini
        // ISO/disco e template, i driver a blocchi (iscsi/nvme-tcp/rbd) SOLO
        // dischi.
        dir: {
          name: 'Dosje lokale',
          desc: 'Një directory e nyjes: e thjeshtë dhe e shpejtë. Është LOKALE për një nyjë, veç kur shtegu është një share vërtet e përbashkët — ta shënosh të përbashkët kur nuk është kushton të dhëna.',
          usage: 'TVirt ruan aty disqe VM-sh, imazhe ISO/disku dhe shabllone.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Një export NFS i montuar nga klasteri — i përbashkët nga natyra.',
          usage: 'Strehon disqe VM-sh, imazhe ISO/disku dhe shabllone.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Një share Windows/Samba e montuar nga klasteri — e përbashkët nga natyra.',
          usage: 'Strehon disqe VM-sh, imazhe ISO/disku dhe shabllone.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Një filesystem në distancë përmes SSH — pa nevojë për export NAS.',
          usage: 'Në roadmap.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'LUN blloku përmes IP me LVM të përbashkët sipër.',
          usage: 'Vetëm disqe — një volum thin për disk; nuk strehon imazhe ISO as shabllone.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Block device të shpërndarë mbi një klaster Ceph.',
          usage: 'Vetëm disqe — një imazh RBD për disk, i hapur nativisht nga QEMU; nuk strehon imazhe ISO.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Filesystem-i i shpërndarë i Ceph, i montuar nga kernel-i në klaster — shared by nature.',
          usage: 'Strehon disqe VM, imazhe ISO/disku dhe shabllone — familja dir mbi një filesystem Ceph (kredenciali cephx i detyrueshëm).'
        },
        fc: { name: 'SCSI/FC', desc: 'LUN SCSI mbi fabric FibreChannel — SAN-i FC klasik.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'I njëjti SCSI mbi FibreChannel, me frame-t FC të kapsuluar në Ethernet.' },

        // Vivo dal round #132 — la chiave è il nome del driver del contract,
        // così il chip della lista storage risolve la stessa voce.
        'iscsi-lun': {
          name: 'iSCSI (LUN të plotë)',
          desc: 'Target-i iSCSI si bartës i LUN-ëve të plotë: çdo disk ËSHTË një LUN, i kaluar i papërpunuar te mysafiri — pa LVM në mes.',
          usage: 'Vetëm disqe — një LUN i plotë për disk, i adoptuar siç është; shtëpia SAN e disqeve me shkrim të ndarë.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (namespace të plotë)',
          desc: 'Nënsistemi NVMe si bartës i namespace-ve të plotë: çdo disk ËSHTË një namespace, i kaluar i papërpunuar te mysafiri.',
          usage: 'Vetëm disqe — një namespace i plotë për disk, i adoptuar siç është; shkrim i ndarë po, SCSI persistent reservations jo.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'NVMe në distancë — asnjë SCSI në shteg — mbi TCP të thjeshtë, me LVM të përbashkët sipër.',
          usage: 'Vetëm disqe — një volum thin për disk; nuk strehon imazhe ISO as shabllone.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'NVMe në distancë mbi fabric FibreChannel.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe mbi fabric-un FibreChannel që FCoE e transporton brenda Ethernet-it — layer-ët FCoE dhe NVMe/FC të stivuar.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI me shtegun e të dhënave të zhvendosur mbi RDMA — çfarëdo fabric-u (InfiniBand, iWARP, RoCE). I tejkaluar nga NVMe/RDMA, ende i pranishëm në array-t dhe në ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'SCSI nativ mbi RDMA, epoka para-iSER: InfiniBand (me discovery të fabric-ut) dhe RoCE — mbijeton në storage-t HPC të vjetruar.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'NVMe në distancë mbi çfarëdo fabric-u RDMA — InfiniBand, iWARP, RoCE v1 dhe v2: një konfigurim i vetëm, është nyja që thotë cilin ka.' },
        s3: { name: 'S3', desc: 'Object storage i përputhshëm me S3 — imazhe dhe backup.' }
      }
    },
    catalogs: {
      title: 'Katalogët',
      createTitle: 'Krijo katalog',
      editTitle: 'Modifiko katalogun',
      docTitle: 'Katalogu',
      notFound: 'Ky katalog nuk ekziston (më?)',
      scopeHint: 'Kush e lexon këtë scope sheh (dhe mund të përdorë) çdo skedar të katalogut',
      files: 'Skedarët',
      noFiles: 'Asnjë skedar',
      count: {
        iso: 'ISO',
        ctRootfs: 'Tpl CT',
        vmTemplate: 'Tpl VM',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },

      // Il catalogo di sistema (round #126): la casa degli oggetti integrati
      // della piattaforma — leggibile da tutti, scrivibile da nessuno.
      systemChip: 'i sistemit',
      systemTooltip: 'Katalogu i sistemit: strehon objektet e integruar të platformës dhe nuk mund të modifikohet'
    },

    // File di catalogo (round K1, inventory v2e/v2g): il catalogo è la casa
    // degli artefatti file del cluster — una lista, titoli per kind.
    catalogFiles: {
      catalog: 'Katalogu',
      kindLabel: 'Tipi',
      physicalSize: 'Madhësia fizike',
      virtualSize: 'Madhësia virtuale',

      // Round K3 (#64) + K4 (#65, ova/ovf con la mappatura boot-survival):
      // materializza un file vm-template come VM Template dell'inventario.
      importTemplateAction: 'Importo si VM Template',
      importTemplateLegacy: 'Asnjë format i deklaruar — i përdorshëm si seed për disqe, i paimportueshëm',
      importTemplateTitle: 'Importo si VM Template',
      importTemplateSubmit: 'Importo',
      importTemplateError: 'Importi nuk u krye',
      importTemplateHint: 'Paketa .tvtpl bëhet një VM Template: hardware-i i ngrirë i manifest-it plus një disk për çdo entry të arkivit, secili i verifikuar kundrejt checksum-it të vet. NIC-et dhe mediat CD/DVD nuk janë pjesë e një arkivi — shtoji pas importit.',
      importTemplateQcow2Hint: 'Një qcow2 i zhveshur bëhet një shabllon me NJË disk me hardware-in default të deklaruar: profil linux, UEFI, 2 vCPU, 2048 MiB, boot nga disku i tij i vetëm. Korrigjoje në deploy.',
      importTemplateName: 'Emri i shabllonit',
      importTemplateNameHint: 'Bosh = {name} (-import-<n> nëse i zënë)',
      importTemplateStorage: 'Storage për disqet',
      importTemplateMetadataStorage: 'Storage i metadatave',
      importTemplateMetadataHint: 'Një storage blloku nuk i strehon metadatat VM (firmware, varstore) — zgjidh një dir/nfs/cifs.',
      importTemplateStarted: 'Importi u nis — shablloni shfaqet në tab-in Shabllonet me mbylljen e task-ut.',

      // Etichette parlanti al singolare (#86): findings e censimento dicono
      // COSA è il file — il generico 'File di catalogo' resta solo fallback.
      kind: {
        iso: 'Imazh ISO',
        'ct-rootfs': 'Rootfs CT',
        'vm-template': 'Shabllon VM',
        'oci-image': 'Imazh OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      title: {
        iso: 'Imazhet ISO',
        'ct-rootfs': 'Shabllonet CT',
        'vm-template': 'Shabllonet VM',
        'oci-image': 'Imazhet OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      createTitle: {
        iso: 'Shto imazh ISO',
        'ct-rootfs': 'Regjistro shabllon CT',
        'vm-template': 'Shto shabllon VM',
        'oci-image': 'Shto imazh OCI',
        'firmware-ovmf': 'Shto firmware OVMF'
      },
      formatHint: 'I derivuar nga prapashtesa e skedarit të zgjedhur — korrigjoje nëse ka gabuar',
      tarballHint: 'Një tarball rootfs në formatin standard LXC (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, ose një .tar i thjeshtë)',
      ociArchiveHint: 'Një tarball docker-archive / oci-archive (.tar ose .tar.gz), për shembull nga docker save',
      uploadResumeHint: 'Upload i ndërprerë — skedari është në pritje të upload-it: dërgoje sërish me të njëjtin skedar për të rifilluar',
      moveTitle: 'Zhvendos skedarin',
      moveHint: 'Dy përmasa të pavarura: Katalogu zhvendos lidhjen (i njëjti id, asnjë byte nuk lëviz, scope-i bëhet ai i katalogut të destinacionit); Storage-i zhvendos të dhënat — çdo kopje e lidhur e ndjek, refuzohet ndërsa skedari është në përdorim. Të zgjedhura bashkë: së pari katalogu, pastaj storage-i.',
      moveCatalog: 'Katalogu i destinacionit',
      moveCatalogHint: 'Vetëm lidhja ndërron shtëpi: një VM që e ka montuar skedarin duhet të mund ta shohë katalogun e destinacionit',
      keepCurrent: 'Mos e ndrysho',
      rehomed: 'Lidhja u zhvendos në katalogun e zgjedhur',
      copyAction: 'Kopjo në katalog…',
      copyTitle: 'Kopjo në katalog',
      copyLinkHint: 'Kopja është një lidhje e re me të njëjtat të dhëna — asgjë nuk duplikohet në storage.',
      copyCatalog: 'Katalogu i destinacionit',
      copyCatalogHint: 'Kopja është mënyra se si një skedar udhëton mes katalogëve',
      sameCatalog: 'I njëjti me burimin',
      sharedObjectHint: 'Të dhënat e këtij skedari ndahen nga {count} kopje të lidhura',
      deleteLastLink: 'Kjo është lidhja e FUNDIT me këtë përmbajtje: do të fshihen edhe të dhënat nga storage-i.',
      deleteLinkOnly: 'Do të hiqet vetëm kjo lidhje — të dhënat mbeten, ende të arritshme nga kopjet e tjera të lidhura ({count}).',
      noCatalog: 'Nuk ka asnjë katalog — krijo një',
      inlineCatalogName: 'Emri i katalogut',

      // File integrati nella piattaforma (round #126): storage null — si
      // leggono e si clonano, mai move/delete/rename.
      embeddedChip: 'i integruar',
      embeddedStorage: 'I integruar në platformë',
      embeddedNoMove: 'Skedar i integruar i platformës: nuk jeton në asnjë storage — klonoje në vend të kësaj',
      embeddedCopyHint: 'Kloni i materializon byte-t e integruar në një storage të vërtetë: zgjidh storage-in dhe katalogun e destinacionit — kopja është një skedar normal',
      sourceEmbedded: 'I integruar në platformë',
      nodesRow: 'Prania sipas nyjes',
      nodesSummary: '{present} nga {total} nyje e kanë',
      nodePresent: 'i pranishëm',
      nodeMissing: 'mungon',
      nodeUnknown: 'ende i paraportuar',
      nodesHint: 'Aseti jeton në diskun e çdo nyjeje (paketa trantor-tvirt-assets): një nyje që nuk e ka nuk mund as të përcaktojë një VM me këtë firmware, as të shërbejë Guest Tools. Versione të ndryshme mes nyjeve janë normale gjatë një përditësimi gradual.',

      // Download (round #108): i byte viaggiano col loro permesso dedicato.
      downloadAction: 'Shkarko',
      downloadNotReady: 'Përmbajtja nuk është ende gati — shkarkimi kërkon një skedar ready',
      downloadDenied: 'Roli yt nuk e përfshin catalog.download — shkarkimi i byte-ve është një e drejtë e ndarë nga përdorimi i skedarit',

      // Round #156 (dialog standard): le righe di lettura mancanti del dialog
      // dettagli — i fatti dell'oggetto condiviso, il checksum dichiarato, gli
      // utilizzatori.
      objectRow: 'Objekti storage',
      objectLinksRow: 'Kopje të lidhura',
      declaredChecksum: 'SHA-256 i deklaruar',
      usedByRow: 'Përdorur nga',
      usedByVms: 'VM',
      usedByDisks: 'Disqe',
      transferRow: 'Transferimi',
      storageLockHint: 'Ndryshohet vetëm me veprimin Zhvendos'
    },

    // Il censimento per-storage (round K1, inventory v2b #2): sola lettura,
    // ogni oggetto si gestisce dalla sua sezione.
    objects: {
      action: 'Eksploro përmbajtjet',
      title: 'Përmbajtjet e storage-it',
      hint: 'Censim vetëm në lexim i asaj që jeton në këtë storage — secili objekt menaxhohet nga seksioni i vet.',
      empty: 'Asnjë objekt i regjistruar në këtë storage',
      loadError: 'Përmbajtjet nuk mund të ngarkoheshin',
      colDetail: 'Detaji',
      manage: 'Menaxho në seksionin e vet',
      kind: {
        disk: 'Disk',
        catalogFile: 'Skedar katalogu',
        ociBlob: 'Blob OCI',
        checkpoint: 'Checkpoint',
        vmMetadata: 'Metadata VM',
        appRoot: 'Root App',
        appVolume: 'Volum App'
      }
    },
    inventory: {
      tabCatalogs: 'Katalogët',
      storage: 'Storage',
      sizeGib: 'Madhësia (GiB)',
      format: 'Formati',
      size: 'Madhësia',
      sourceType: 'Burimi',
      sourceFile: 'Ngarkim skedari',
      sourceUrl: 'Shkarkim nga URL',
      file: 'Skedari',
      url: 'URL',
      checksum: 'Checksum SHA-256',
      checksumHint: 'I detyrueshëm: shkarkimi verifikohet kundrejt këtij SHA-256',
      verifyChecksum: 'Verifiko checksum-in',
      checksumOffHint: 'Shkarkimi do të pranohet pa verifikim — SHA-256-a e llogaritur regjistrohet gjithsesi',
      uploading: 'Duke ngarkuar…',
      move: {
        action: 'Zhvendos',
        diskTitle: 'Zhvendos diskun',
        target: 'Storage-i i destinacionit',
        diskHint: 'Disku e ruan identitetin e vet: byte-t udhëtojnë në storage-in e zgjedhur. Një VM që e përdor duhet të jetë e fikur; me snapshot-e të pranishëm një anë iSCSI e refuzon zhvendosjen.',
        noTargets: 'Asnjë storage destinacioni i përputhshëm',
        submit: 'Zhvendos',
        error: 'Zhvendosja u refuzua'
      },
      clone: {
        action: 'Klono',
        title: 'Klono diskun',
        name: 'Emri i kopjes',
        storage: 'Storage-i i destinacionit',
        sameStorage: 'I njëjti me burimin',
        linked: 'Linked clone',
        linkedHint: 'Overlay qcow2 i menjëhershëm i vargëzuar me diskun burim (vetëm burime qcow2). Default-i është një kopje e plotë.',
        linkedCrossHint: 'Një linked clone mbetet në storage-in e burimit: zgjidh "I njëjti me burimin" për ta aktivizuar.',
        submit: 'Klono',
        error: 'Klonimi u refuzua'
      },
      copy: {
        action: 'Kopjo',
        name: 'Emri i kopjes',
        storage: 'Storage-i i destinacionit',
        sameStorage: 'I njëjti me burimin',
        submit: 'Kopjo',
        error: 'Kopjimi u refuzua'
      },
      taskStarted: 'U nis — vazhdon si task në background',
      cephObjects: 'Shko te detajet e objektit në Ceph',
      phase: {
        ready: 'Gati',
        creating: 'Në krijim',
        'awaiting-upload': 'Në pritje të upload-it',
        downloading: 'Në shkarkim',
        verifying: 'Në verifikim',
        deleting: 'Duke u fshirë',
        error: 'Gabim',
        'in-use': 'Në përdorim'
      }
    }
  }
}
